import { isCurrencyCodeString } from './currencyTypes';
import { getApiNameByLevel } from './getApiNameByLevel';
import { mapToPresentationalCards, mapToSchemaProducts, mapToStandaloneProducts } from './mapToPresentationalCards';
const DEFAULT_CARD_COUNT = 4;
export function buildPricingPageViewModel(data, opts) {
  const {
    selectedTerm,
    isEnterpriseTier,
    displayedCurrencyCode
  } = opts;
  const allCards = mapToPresentationalCards(data, selectedTerm);
  const cards = isEnterpriseTier ? allCards.filter(card => card.productLevel === 'PROFESSIONAL' || card.productLevel === 'ENTERPRISE') : allCards;
  const cardCount = isEnterpriseTier ? 2 : DEFAULT_CARD_COUNT;
  const standaloneProducts = mapToStandaloneProducts(data, selectedTerm);
  const schemaProducts = mapToSchemaProducts(data, selectedTerm);
  const currencyCode = isCurrencyCodeString(data.currencyCode) ? data.currencyCode : displayedCurrencyCode;
  return {
    cards,
    cardCount,
    standaloneProducts,
    schemaProducts,
    currencyCode,
    hasStarterTier: getApiNameByLevel(allCards, 'STARTER') !== undefined,
    starterApiName: getApiNameByLevel(cards, 'STARTER'),
    professionalApiName: getApiNameByLevel(cards, 'PROFESSIONAL'),
    enterpriseApiName: getApiNameByLevel(cards, 'ENTERPRISE')
  };
}